<template>
  <div>
    <altcha-widget
      ref="altchaWidget"
      challengeurl="/api/altcha"
      :strings="strings"
      :auto="auto"
      floating="auto"
      name="a_c"
      hidelogo
      hidefooter
    ></altcha-widget>
  </div>
</template>

<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import Vue from "vue";
import Component from "vue-class-component";
import 'altcha';

@Component({})
export default class Altcha extends Vue {
  @Prop({ type: String, default: "onload" }) readonly auto!: string;
  @Prop({type: String}) value!: string|null;

  internalValue: string|null = null;

  $refs!: {
    altchaWidget: HTMLElement;
  };

  @Watch('internalValue')
  onInternalValueChange(value: string) {
    this.$emit('input', value || null);
  }

  created() {
    this.$emit('input', null);
  }

  mounted() {
    if (this.$refs.altchaWidget) {
      this.$refs.altchaWidget.addEventListener('statechange', this.onStateChange);
    }
  }

  beforeDestroy() {
    if (this.$refs.altchaWidget) {
      this.$refs.altchaWidget.removeEventListener('statechange', this.onStateChange);
    }
  }

  onStateChange(ev: CustomEvent | Event) {
    if ('detail' in ev) {
      const { payload, state } = ev.detail;
      if (state === 'verified' && payload) {
        this.internalValue = payload;
      } else {
        this.internalValue = null;
      }
    }
  }

  get strings() {
    return JSON.stringify({
      error: this.$t("CAPTCHA_ERROR"),
      expired: this.$t("CAPTCHA_ERROR"),
      footer: "",
      label: this.$t("CAPTCHA_LABEL"),
      verified: this.$t("CAPTCHA_VERIFIED"),
      verifying: this.$t("CAPTCHA_VERIFYING"),
      waitAlert: this.$t("CAPTCHA_WAIT_ALERT"),
    });
  }
}

</script>
<style lang="scss" scoped>
.altcha {
  &[data-state="verifying"], &[data-state="verified"] {
    visibility: hidden;
  }
}
</style>
